export default function ImportInfo() {
  return (
    <div className="bg-blue-50 border border-blue-100 rounded-xl p-4">
      <p className="text-sm font-medium text-blue-800 mb-2">Como funciona:</p>
      <div className="text-xs text-blue-700 space-y-1">
        <p>1. Baixe o modelo Excel com os campos necessarios</p>
        <p>2. Preencha os dados dos clientes (Nome e CPF/CNPJ obrigatorios)</p>
        <p>3. Faca o upload da planilha preenchida</p>
        <p>4. Clientes com dados incompletos ficam com badge de pendencia</p>
      </div>
    </div>
  );
}
